import React from 'react';
import { useDispatch } from 'react-redux';

import { addErrorMessage, addSuccessMessage } from 'features/message/redux/action';

export const useMessage = () => {
  const dispatch = useDispatch();

  const showErrorMessage = React.useCallback(
    (message: string) => {
      dispatch(addErrorMessage(message));
    },
    [dispatch]
  );

  const showSuccessMessage = React.useCallback(
    (message: string) => {
      dispatch(addSuccessMessage(message));
    },
    [dispatch]
  );

  return { showErrorMessage, showSuccessMessage };
};
